import { render, staticRenderFns } from "./bindShop.vue?vue&type=template&id=90fb3730&scoped=true"
import script from "./bindShop.vue?vue&type=script&lang=js"
export * from "./bindShop.vue?vue&type=script&lang=js"
import style0 from "./bindShop.vue?vue&type=style&index=0&id=90fb3730&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb3730",
  null
  
)

export default component.exports